import React from 'react';
import {
  Outlet,
} from 'react-router-dom';
import ConfirmationDialogProvider from 'pages/Dashboard/contexts/confirmationDialog';

export default function SupportLayout() {
  return (
    <ConfirmationDialogProvider>
      <Outlet />
    </ConfirmationDialogProvider>
  );
}
